import axios from 'axios'
import { host } from '../../../helper/config'

const PLUGINS_NAME = 'admin-loto-channel'

export const getAllChannel = async (token) => {
    const response = await axios.get(`${host}/${PLUGINS_NAME}/get-list`, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const getChannelsByRegion = async (token, region) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list-by-region`, {
        region
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const updateChannelWeekdays = async (token, id, weekdays) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update-weekdays`, {
        id,
        weekdays
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const toggleChannelHasLoto = async (token, id, hasLoto) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/toggle-has-loto`, {
        id,
        hasLoto
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}
